import { socialApiClient } from '@/shared/api-client/social-api-client';
import { exportToCSV } from '@/shared/utils/export-to-csv';
import z from 'zod';

export const exportDiscoveryCreatorListRequestSchema = z.union([
  z.object({
    search_id: z.string(),
    selected_all: z.boolean(),
  }),
  z.object({
    creator_ids: z.array(z.string()).optional(),
    selected_all: z.boolean(),
  }),
]);

export type ExportDiscoveryCreatorListRequest = z.infer<
  typeof exportDiscoveryCreatorListRequestSchema
>;

export async function exportDiscoveryCreatorList(
  listId: string,
  fileName: string,
  request: ExportDiscoveryCreatorListRequest,
  signal?: AbortSignal,
) {
  const validatedRequest = exportDiscoveryCreatorListRequestSchema.parse(request);
  const response = await socialApiClient.post(`creators/saved-lists/${listId}/export`, {
    json: validatedRequest,
    signal,
  });
  const text = await response.text();

  exportToCSV(text, fileName);
}
